<template>
  <b-navbar
    id="mainNav"
    :class="{ 'navbar-on-top': isScrollTop }"
    fixed="top"
    toggleable="md"
  >
    <b-container>
      <b-navbar-brand href="/">JHLEE's HOME</b-navbar-brand>
      <b-navbar-toggle target="collapsibleNavbar"> MENU </b-navbar-toggle>
      <b-collapse id="collapsibleNavbar" is-nav>
        <b-navbar-nav class="text-uppercase me-auto">
          <template v-for="(item, index) in tabMenus">
            <template v-if="item.type == 'link'">
              <b-nav-item
                v-if="item.link"
                :href="item.link"
                :key="item + index"
                >{{ item.text }}</b-nav-item
              >
            </template>
            <template v-else-if="item.type == 'scroll'">
              <b-nav-item v-scroll-to="item.scrollTo" :key="item + index">{{
                item.text
              }}</b-nav-item>
            </template>
          </template>
        </b-navbar-nav>
        <b-navbar-nav class="text-uppercase ms-auto">
          <template v-for="(item, index) in rightMenus">
            <template v-if="item.type == 'link'">
              <b-nav-item :href="item.link" :key="item + index">{{
                item.text
              }}</b-nav-item>
            </template>
            <template v-else-if="item.type == 'button'">
              <b-nav-item @click="item.click" :key="item + index">{{
                item.text
              }}</b-nav-item>
            </template>
          </template>
        </b-navbar-nav>
      </b-collapse>
    </b-container>
  </b-navbar>
</template>

<script>
export default {
  data: function () {
    return {
      isScrollTop: true,
    };
  },
  mounted() {
    this.updateIsScrollTop();
    window.addEventListener('scroll', this.updateIsScrollTop);
  },
  unmounted() {
    window.removeEventListener('scroll', this.updateIsScrollTop);
  },
  methods: {
    updateIsScrollTop() {
      this.isScrollTop = window.pageYOffset <= 84;
    },
  },
  props: {
    type: {
      type: String,
      default: 'index',
      validator(val) {
        return ['index'].includes(val);
      },
    },
  },
  computed: {
    tabMenus() {
      if (this.type === 'index') {
        return [
          { type: 'scroll', text: '인사말', scrollTo: '#hello-section' },
          { type: 'scroll', text: '소개', scrollTo: '#introduce-section' },
          {
            type: 'scroll',
            text: '주요 프로젝트',
            scrollTo: '#fortfolio-section',
          },
        ];
      } else {
        return [{ type: 'link', text: '메인', link: '/' }];
      }
    },
    rightMenus() {
      if (this.type == 'index') {
        return [];
      } else {
        return [];
      }
    },
  },
};
</script>

<style>
/* mainNav 스타일 */
#mainNav {
  background-color: #212121;

  -webkit-transition: all 0.3s;
  -khtml-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

#mainNav .navbar-brand {
  color: #bfa288;
  font-family: 'Anton', Helvetica, sans-serif;
  font-size: 24px;

  -webkit-transition: all 0.3s;
  -khtml-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

#mainNav .navbar-brand:hover,
#mainNav .navbar-brand:focus {
  color: #735645;
}

#mainNav .nav-link {
  color: #f2f2f2;
  font-size: 16px;
  font-weight: bold;

  -webkit-transition: all 0.3s;
  -khtml-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

#mainNav .nav-link:hover,
#mainNav .nav-link:focus,
#mainNav .nav-link:active {
  color: #a6978f;
}

#mainNav .navbar-toggler {
  padding: 10px 5px;
  font-weight: bold;
  background-color: #735645;
  color: #d9d9d9;
}

#mainNav .navbar-toggler:focus,
#mainNav .navbar-toggler:active {
  outline: none;
  box-shadow: none;
}

@media (min-width: 768px) {
  #mainNav .nav-link {
    padding: 0px 20px;
  }

  /* mainNav가 최상단에 붙어 있을 때 */
  #mainNav.navbar-on-top {
    padding-top: 10px;
    padding-bottom: 10px;
    background-color: transparent;
  }

  #mainNav.navbar-on-top .navbar-brand {
    font-size: 36px;
  }

  #mainNav.navbar-on-top .nav-link {
    font-size: 20px;
    padding: 0px 16px;
    text-shadow: 1px 1px #40221155;
  }
}
</style>
